<template src="./search-template.vue" />
<script>
import indexMixin from './index-mixin';

export default {
  name: 'SearchComponent',

  mixins: [indexMixin],

  data() {
    return {
      config: {
        type: 'jobs',
        sortFields: [
          {
            title: 'Most Relevant',
            value: 'most_relevant',
          },
          {
            title: 'Closest Deadline',
            value: 'deadline-asc',
          },
          {
            title: 'Furthest Deadline',
            value: 'deadline-desc',
          },
          {
            title: 'Newest (Date Added)',
            value: 'date-desc',
          },
          {
            title: 'Oldest (Date Added)',
            value: 'date-asc',
          },
        ],
        availableFilters: {
          jobType: true,
          jobRole: true,
          location: true,
          ted: true,
          companyIndustry: false,
        },
      },
    };
  },
};
</script>
